import { render, staticRenderFns } from "./AssignLeads.vue?vue&type=template&id=188afea4&scoped=true&"
import script from "./AssignLeads.vue?vue&type=script&lang=js&"
export * from "./AssignLeads.vue?vue&type=script&lang=js&"
import style0 from "./AssignLeads.vue?vue&type=style&index=0&id=188afea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188afea4",
  null
  
)

export default component.exports